let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eqGf1")).then(() => parcelRequire('Nw44h'));